var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlutter1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 240,
    height: 120,
    viewBox: "0 0 240 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111220",
    "data-name": "Path 111220",
    d: "M53.81,28.876,37.434,45.258,53.81,61.639H35.1l-7.022-7.022-9.359-9.359L35.1,28.876ZM35.1.8,4.682,31.219l9.359,9.359L53.81.8H35.1Z",
    transform: "translate(-4.682 -0.804)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -89.486,
    y1: -632.996,
    x2: -87.478,
    y2: -635.974,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a237e",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a237e",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -27.315,
    cy: -8.995,
    r: 0.047,
    gradientTransform: "translate(-57.238) scale(1.238 1)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.102
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-_06"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 120
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_06",
    "data-name": 6,
    clipPath: "url(#clip-_06)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flutter-seeklogo.com",
    transform: "translate(31.879 20.521)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20006",
    "data-name": "Group 20006",
    transform: "translate(4.121 8.966)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19997",
    "data-name": "Group 19997",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19996",
    "data-name": "Group 19996",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111219",
    "data-name": "Path 111219",
    d: "M23.34,45.151,49.076,19.41H30.363L13.987,35.792Z",
    transform: "translate(0.052 8.662)",
    fill: "#39cefd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19999",
    "data-name": "Group 19999",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19998",
    "data-name": "Group 19998",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111221",
    "data-name": "Path 111221",
    d: "M4.682,31.219,35.1.8H53.81L14.041,40.578Z",
    transform: "translate(-4.682 -0.804)",
    fill: "#39cefd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20001",
    "data-name": "Group 20001",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20000",
    "data-name": "Group 20000",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111223",
    "data-name": "Path 111223",
    d: "M27.209,46.644H45.922L29.546,30.268l-9.359,9.359Z",
    transform: "translate(3.206 14.186)",
    fill: "#03569b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20003",
    "data-name": "Group 20003",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20002",
    "data-name": "Group 20002",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111225",
    "data-name": "Path 111225",
    d: "M29.546,30.268l-9.359,9.359,13.881-4.809Z",
    transform: "translate(3.206 14.186)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20005",
    "data-name": "Group 20005",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20004",
    "data-name": "Group 20004",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111227",
    "data-name": "Path 111227",
    d: "M13.987,33.42l9.359-9.359,9.359,9.359-9.359,9.365Z",
    transform: "translate(0.052 11.028)",
    fill: "#16b9fd"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_111229",
    "data-name": "Path 111229",
    d: "M53.81,28.876,37.434,45.258,53.81,61.639H35.1l-7.022-7.022-9.359-9.359L35.1,28.876ZM35.1.8,4.682,31.219l9.359,9.359L53.81.8H35.1Z",
    transform: "translate(-4.682 -0.804)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20007",
    "data-name": "Group 20007",
    transform: "translate(59.173 25.272)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111230",
    "data-name": "Path 111230",
    d: "M42.549,20.809h16.4v3.124H45.985v9.684H57.7V36.74H45.985V48.924h-3.28V20.809Z",
    transform: "translate(-42.549 -20.809)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111231",
    "data-name": "Path 111231",
    d: "M56.008,20.809h3.28V49.08h-3.28Z",
    transform: "translate(-35.702 -20.809)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111232",
    "data-name": "Path 111232",
    d: "M68.888,46.966a7.4,7.4,0,0,1-5.623-2.187,8.726,8.726,0,0,1-1.874-5.935V26.192h3.28V38.375a6.464,6.464,0,0,0,1.25,4.217A4.705,4.705,0,0,0,69.513,44a4.806,4.806,0,0,0,2.968-.937,5.838,5.838,0,0,0,2.031-2.343,7.11,7.11,0,0,0,.781-3.124v-11.4h3.28V46.341H75.448V43.373h-.156a6.866,6.866,0,0,1-2.655,2.5A6.227,6.227,0,0,1,68.888,46.966Z",
    transform: "translate(-32.964 -18.07)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111233",
    "data-name": "Path 111233",
    d: "M84.635,48.549a6.267,6.267,0,0,1-2.343-.469,6.45,6.45,0,0,1-1.718-1.093,6.935,6.935,0,0,1-1.25-1.718,5.216,5.216,0,0,1-.469-2.343V31.056H75.263V28.088h3.592V22.465h3.28v5.623h4.842v2.968H82.136V41.989a3.963,3.963,0,0,0,.625,2.5,2.621,2.621,0,0,0,2.187.937,3.586,3.586,0,0,0,2.187-.625v3.28c-.469.156-.781.312-1.25.469Z",
    transform: "translate(-25.906 -19.966)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111234",
    "data-name": "Path 111234",
    d: "M93.951,48.549a6.267,6.267,0,0,1-2.343-.469,6.449,6.449,0,0,1-1.718-1.093,6.935,6.935,0,0,1-1.25-1.718,5.216,5.216,0,0,1-.469-2.343V31.056h-3.28V28.088h3.592V22.465h3.28v5.623h4.842v2.968H91.764V41.989a3.963,3.963,0,0,0,.625,2.5,2.621,2.621,0,0,0,2.187.937,3.586,3.586,0,0,0,2.187-.625v3.28c-.469.156-.781.312-1.25.469Z",
    transform: "translate(-21.008 -19.966)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111235",
    "data-name": "Path 111235",
    d: "M104.1,47.124a9.831,9.831,0,0,1-5.154-1.406,10.338,10.338,0,0,1-3.592-3.749,12.253,12.253,0,0,1-1.25-5.467,12.081,12.081,0,0,1,1.25-5.311,10.393,10.393,0,0,1,3.436-3.9A9.517,9.517,0,0,1,112.38,30.88a11.583,11.583,0,0,1,1.25,5.311,2.316,2.316,0,0,1-.156,1.093H97.385a9.565,9.565,0,0,0,1.093,3.9,5.958,5.958,0,0,0,2.5,2.343,7.683,7.683,0,0,0,3.124.781,6.547,6.547,0,0,0,5.935-3.592l2.811,1.406a10.8,10.8,0,0,1-3.592,3.9,11.5,11.5,0,0,1-5.154,1.093Zm5.779-12.808a5.185,5.185,0,0,0-.781-2.5,6.668,6.668,0,0,0-2.031-2.187,5.94,5.94,0,0,0-3.436-.937,5.531,5.531,0,0,0-4.061,1.562,7.848,7.848,0,0,0-2.187,4.061Z",
    transform: "translate(-16.321 -18.228)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111236",
    "data-name": "Path 111236",
    d: "M109.531,26.35h3.124v3.28h.156a4.83,4.83,0,0,1,2.343-2.655,6.078,6.078,0,0,1,3.592-1.093,5.216,5.216,0,0,1,2.343.469v3.592a5.349,5.349,0,0,0-2.811-.625,5.266,5.266,0,0,0-2.655.781,9.129,9.129,0,0,0-2.031,2.187,6.46,6.46,0,0,0-.781,2.968V46.5h-3.28Z",
    transform: "translate(-8.473 -18.228)",
    fill: "gray"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutter1);
export default __webpack_public_path__ + "static/media/flutter-1.b12ff1f525421c2410370d1b5a4bfffd.svg";
export { ForwardRef as ReactComponent };